import * as React from 'react'
import { OfferInstance } from '../../../../models/Offer'
import { HeadlineCSS } from '../../../../shared/components/Headlines'
import { breakpoint, styled } from '../../../../shared/styled-components'
import { Text } from '../../../../shared/components/Elements'
import { Utils } from '../../../../shared/Utils'

interface IProps {
  offer: OfferInstance
}

export const CodeBadge = ({ offer }: IProps) => {
  return (
    <Container>
      <CodeHeadline>Zeigen Sie Ihrem Zahnarzt diesen Code:</CodeHeadline>
      <Top>
        <Code>{offer.code}</Code>
      </Top>
      <Bottom>
        Bericht drucken:
        <PrintButton onClick={() => window.print()}>
          <PrintIcon src={Utils.getAssetPath('/assets/calculator/result/print.svg')} />
        </PrintButton>
      </Bottom>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: ${(props) => props.theme.blueColor};
  padding: 15px 20px;
  color: ${(props) => props.theme.greenColor};
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.03);
  margin: 20px 0;
  width: 260px;
  @media (max-width: 950px) {
    padding: 15px 20px 0px 20px;
  }
  @media (max-width: 600px) {
    width: calc(100vw - 20px);
    border-radius: 10px 0 0 10px;
    flex-direction: row;
    padding: 10px 20px 0 20px;
  } 
  @media print { 
  -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;                 /* Firefox 48 – 96 */
    print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
  }
`

const Top = styled.div`
  flex: 1 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${breakpoint('tablet')`
    flex-basis: 0;
  `};
`

const Bottom = styled.div`
  flex: 1 0 0;
  padding-left: 40px;
  display: flex;
  flex-direction: row;
  color: ${(props) => props.theme.greenColor};
  padding-top: 1rem;
 @media (max-width: 950px) {
    padding-top: 0;
    padding-left: 34px;
  }
  @media (max-width: 600px) {
    font-size: 0px;
  }
  @media print { 
  display: none;
  }
`

const Code = styled.div`
  border-radius: 15px;
  background: white;
  color: ${(props) => props.theme.goldColor};
  line-height: 30px;
  text-align: center;
  font-weight: 500;
  letter-spacing: 1px;
  margin-bottom: 10px;
  ${breakpoint('tablet')`
    margin-bottom: 0;
  `}
   @media (max-width: 600px) {
    border-radius: 6px;
    font-size: 16px;
    width: 120px;
  }
`

const CodeHeadline = styled.div`
  ${HeadlineCSS};
  font-size: 18px !important;
  line-height: 24px;
  color: white;
  font-weight: 300;
  margin-bottom: 10px;
  text-align: center;
@media (max-width: 950px) {
    font-size: 12px !important;
  }
@media (max-width: 600px) {
    font-size: 10px !important;
    line-height: 130%;
    text-align: left;
  }
`

const PrintButton = styled.div`
  cursor: pointer;
  padding: 10px;
`

const PrintIcon = styled.img`
  margin-top: -10px;
`
